import React, { useState } from 'react';
import { Table, Button, Box, Stack, Modal } from '@mui/material';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Card from '@mui/material/Card';
import AllEventBody from './AllEventBody';
import Snackbar from '../../../../../misc/Snackbar';
import AddMasterClass from './AddMasterClass';
import AddOtherEvent from './AddOtherEvent';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  height: '100%',
  overflow: 'scroll',
  transform: 'translate(-50%, -50%)',
  width: 800,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

const AllEventHeader = ({ data, currentBatch }) => {
  const [open, setOpen] = useState(false);
  const [openOther, setOpenOther] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCloseOther = () => setOpenOther(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarText, setSnackbarText] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('');
  return (
    <div>
      <Stack
        direction='row'
        justifyContent='flex-end'
        alignItems='center'
        spacing={1}
        mb={2}
      >
        <Button variant='outlined' onClick={() => handleOpen()}>
          Add New Masterclass
        </Button>
        <Button variant='outlined' onClick={() => setOpenOther(true)}>
          Add New Coach connect or Mentor connect
        </Button>
      </Stack>
      <TableContainer component={Card}>
        <Table
          size='small'
          sx={{ minWidth: 650, borderRadius: 2, shadow: 2 }}
          aria-label='table'
        >
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              <TableCell>Name</TableCell>
              <TableCell align='left'> Event Type</TableCell>
              <TableCell align='left'>Date</TableCell>
              <TableCell align='left'>Link</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((event) => {
              return (
                <AllEventBody
                  key={event._id}
                  event={event}
                  currentBatch={currentBatch}
                />
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <AddMasterClass
            currentBatch={currentBatch}
            handleClose={handleClose}
            snackbarActions={{
              setSnackbarText,
              setSnackbarSeverity,
              setSnackbarOpen,
            }}
          />
        </Box>
      </Modal>
      <Modal
        open={openOther}
        onClose={handleCloseOther}
        aria-labelledby='modal-modal-title'
        aria-describedby='modal-modal-description'
      >
        <Box sx={style}>
          <AddOtherEvent
            currentBatch={currentBatch}
            handleClose={handleCloseOther}
            snackbarActions={{
              setSnackbarText,
              setSnackbarSeverity,
              setSnackbarOpen,
            }}
          />
        </Box>
      </Modal>
      <Snackbar
        open={snackbarOpen}
        setOpen={setSnackbarOpen}
        duration={3000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        title={snackbarText}
        severity={snackbarSeverity}
      ></Snackbar>
    </div>
  );
};

export default AllEventHeader;
